function findDataByNormalizedKey(dataObj: any, normalizedKey: string): any {
    for (const key in dataObj) {
        if (key.trim().toLowerCase() === normalizedKey) {
            return dataObj[key];
        }
    }
    return null;
}

interface VinPopupData {
    exportVinList: any[];
    exportTitleCenter: string;
    exportMonthName: string;
}

export function getVinPopupData(
    summaryJson: any,
    rangeFrom: any,
    monthHeaders: string[],
    gCommonList: (arg: string) => any[],
    rowKey: string,
    colIndex: number,
    rowVins?: any[]
): VinPopupData {
    const result: VinPopupData = {
        exportVinList: [],
        exportTitleCenter: '',
        exportMonthName: ''
    };

    if (!summaryJson?.actual) return result;

    if (rowKey === 'globalTotal') {
        const allVins = rowVins || [];

        const isTotalColumn = (colIndex === monthHeaders.length);

        if (!isTotalColumn) {
            const targetMonth = rangeFrom.from + colIndex + 1;
            result.exportVinList = allVins.filter((vin: any) =>
                vin.Mes === targetMonth && vin.Anyo === rangeFrom.year
            );
            result.exportMonthName = gCommonList('months')[rangeFrom.from + colIndex].name;
        } else {
            const startMonth = rangeFrom.from + 1;
            const endMonth = rangeFrom.to + 1;
            result.exportVinList = allVins.filter((vin: any) =>
                vin.Anyo === rangeFrom.year &&
                vin.Mes >= startMonth &&
                vin.Mes <= endMonth
            );

            if (rangeFrom.from === rangeFrom.to) {
                result.exportMonthName = gCommonList('months')[rangeFrom.from]?.name || 'Total';
            } else {
                const startName = gCommonList('months')[rangeFrom.from]?.name;
                const endName = gCommonList('months')[rangeFrom.to]?.name;
                result.exportMonthName = `${startName} - ${endName}`;
            }
        }
        result.exportTitleCenter = 'TOTAL ' + rowKey.toUpperCase();
        return result;
    }

    if (rowKey.startsWith('item-')) {
        const splitted = rowKey.split('-');
        if (splitted.length < 3) {
            return result;
        }
        const centro = splitted[1];
        const modelo = splitted[2];

        const dataFound = findDataByNormalizedKey(summaryJson.actual, centro);
        const arr = Array.isArray(dataFound)
            ? dataFound
            : (dataFound && Array.isArray(dataFound.Detalle)
                ? dataFound.Detalle
                : []);

        let matched = [];
        if (colIndex === monthHeaders.length) {
            matched = arr.filter((item: any) =>
                item.ModeloDn.trim().toLowerCase() === modelo && item.Anyo === rangeFrom.year
            );
        } else {
            const mesNumero = rangeFrom.from + colIndex + 1;
            matched = arr.filter((item: any) =>
                item.ModeloDn.trim().toLowerCase() === modelo &&
                item.Anyo === rangeFrom.year &&
                item.Mes === mesNumero
            );
            if (matched.length === 0) {
                matched = arr.filter((item: any) =>
                    item.ModeloDn.trim().toLowerCase() === modelo && item.Anyo === rangeFrom.year
                );
            }
        }

        matched = matched.filter((item: any) => Number(item.Cantidad) > 0);

        result.exportVinList = matched;
        result.exportTitleCenter = modelo.toUpperCase();
        if (colIndex === monthHeaders.length) {
            result.exportMonthName = 'Total';
        } else {
            result.exportMonthName = gCommonList('months')[rangeFrom.from + colIndex].name;
        }
        return result;
    } else if (rowKey.startsWith('center-')) {
        const centro = rowKey.replace('center-', '').trim();
        let aggregated: any[] = [];
        for (const key in summaryJson.actual) {
            if (key.trim().toLowerCase() === centro) {
                const data = summaryJson.actual[key];
                const items = Array.isArray(data)
                    ? data
                    : (data && Array.isArray(data.Detalle) ? data.Detalle : []);
                aggregated = aggregated.concat(items);
            }
        }

        aggregated = aggregated.filter((item: any) => Number(item.Cantidad) > 0);

        if (colIndex !== monthHeaders.length) {
            const targetMonth = rangeFrom.from + colIndex + 1;
            aggregated = aggregated.filter((item: any) => item.Mes === targetMonth);
        }
        result.exportVinList = aggregated;
        result.exportTitleCenter = centro.toUpperCase();
        if (colIndex === monthHeaders.length) {
            result.exportMonthName = rangeFrom.from === rangeFrom.to
                ? gCommonList('months')[rangeFrom.from].name
                : `${gCommonList('months')[rangeFrom.from].name} - ${gCommonList('months')[rangeFrom.to].name}`;
        } else {
            result.exportMonthName = gCommonList('months')[rangeFrom.from + colIndex].name;
        }
        return result;
    }

    return result;
}
